import { useState, React } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Zoom from "react-reveal/Zoom";
import pic from "../images/banner2.jpg";
import food1 from "../images/gallery/6.jpg";
import food2 from "../images/gallery/9.jpg";
import food3 from "../images/gallery/8.jpg";
import food4 from "../images/gallery/7.jpg";
import $ from "jquery";
import Modal from "react-bootstrap/Modal";
import { Navigation } from "swiper";
import whatsapp from "../images/whatsapp.png";
import smartphone from "../images/smartphone.png";
import pic1 from "../images/gallery/1.jpg";
import ficon1 from "../images/vegetable.png";
import pic3 from "../images/download (1).jpg";
import ficon2 from "../images/serve.png";
import ficon3 from "../images/man.png";
import ficon4 from "../images/dish.png";
import aboutpic from "../images/download (1).jpg";
import cheese from "../images/gallery/12.jpg";
import Slide from "react-reveal/Slide";

// Import Swiper styles

import "swiper/css";
import "swiper/css/pagination";
import Footer from "./Footer";
import "../css/Footer.css";
import { MetaTags } from "react-meta-tags";
// import required modules
import { Pagination } from "swiper";
const Home = () => {
  const formSubmit = () => {
    var custName;
    var custEmail;
    var custPhone;
    var custAge;
    var custMessage;

    if ($("#custName").val() !== "") {
      custName = $("#custName").val();
    } else {
    }
    if ($("#custPhone").val() !== "") {
      custPhone = $("#custPhone").val();
    } else {
    }

    if ($("#custEmail").val() !== "") {
      custEmail = $("#custEmail").val();
    } else {
    }

    if ($("#custMessage").val() !== "") {
      custMessage = $("#custMessage").val();
    } else {
    }

    var body =
      '<!DOCTYPE html><html><head><title>The Express Caterers</title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><meta http-equiv="X-UA-Compatible" content="IE=edge"></head><body style="margin:0!important;padding:0!important;background-color:#eee" bgcolor="#eeeeee"><div style="display:none;font-size:1px;color:#fefefe;line-height:1px;font-family:Open Sans,Helvetica,Arial,sans-serif;max-height:0;max-width:0;opacity:0;overflow:hidden"></div><table border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="#fff"><tr><td align="center" style="background-color:#eee" bgcolor="#eeeeee"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td align="center" valign="top" style="font-size:0;padding:10px" bgcolor="#e56f35"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:6px;font-weight:800;line-height:10px" class="mobile-center"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;line-height:24px;padding:10px"><a href="tel:+91" style="text-decoration:none;color:#fff;font-family:serif;font-size:16px">Leads Generate for The Express Caterers</a></td></tr></table></td></tr></table></div></td></tr><tr><td align="center" valign="top" style="font-size:0;padding:15px" bgcolor="#fff"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:36px;font-weight:800;line-height:48px" class="mobile-center"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-weight:800"><img style="width:120px;height:120px" src="" alt=""></td></tr></table></td></tr></table></div></td></tr><tr><td align="center" valign="top" style="font-size:0;padding:0" bgcolor="#e56f35"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td width="100%" align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;padding:10px 0" class="mobile-center"><h1 style="text-transform:capitalize;font-size:14px;font-weight:500;margin:0;text-align:center;color:#fff">Client Enquiry Details</h1></td></tr></table></div></td></tr><tr><td align="center" height="100%" valign="top" width="100%" style="padding:0 35px 35px 35px;background-color:#fff" bgcolor="#eee"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:660px"><tr><td width="100%" align="center" valign="top" style="font-size:0"><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;text-align:center;width:100%"><table width="100%" align="center" border="0" cellpadding="0" cellspacing="0" style="max-width:300px"><tr><td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#e56f35">Customer Name:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custName +
      '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#e56f35">Customer Number:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custPhone +
      '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#164388">Customer Email:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custEmail +
      '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#164388">Customer Messagee:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custMessage +
      '</p></td></tr></table></div></td></tr></table></td></tr><tr><td width="100%" align="center" bgcolor="#e56f35" style="padding:10px 0"><p style="color:#fff;font-weight:500;font-size:1rem;padding:0;margin:0">© Copyright 2023 The Express Caterers</p></td></tr></table></td></tr></table></body></html>';

    $.post(
      "https://skdm.in/server/v1/send_lead_mail.php",
      {
        toEmail: "theexpresscaterers@gmail.com",

        fromEmail: "skdmlead@gmail.com",
        bccMail: "skdmlead@gmail.com",
        mailSubject: "New Lead genration",
        mailBody: body,
        accountName: "Express cater",
        accountLeadSource: "",
        accountLeadName: custName,
        accountLeadPhone: custPhone,
        accountLeadEmail: custEmail,
        accountLeadMsgs: custMessage,
      },

      function (dataa, status) {
        console.log("data :" + dataa);
        console.log("name:" + custName);
      }
    );

    alert("Your Form has Submited Our team will contact with You  soon.");

    window.location.reload();

    return false;
  };
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);
  return (
    <>
      {/* --------------------------------seo start--------------------------------- */}
      <MetaTags>
        <title>
          {" "}
          Caterers in Dahisar | The Express Caters
        </title>
        <meta name="google-site-verification" content="7SedB4wBTSXQ-5jGmNcsjt5cV7hPKrgS31utL8lPh3c" />
        <meta
          name="description"
          content="Looking for reliable Caterers in Dahisar?The Express catering services provide the best culinary experience for your events."
        />
        <meta
          name="keywords"
          content="Caterers in Dahisar,
          Wedding Caterers in Dahisar,
          Best Cateres In Dahisar,
          Party Cateres In Dahisar,
          Best food Cateres In Dahisar"
        />
        <meta
          property="og:title"
          content="Caterers in Dahisar"
        />
        <meta
          property="og:description"
          content="Looking for reliable Caterers in Dahisar?The Express catering services provide the best culinary experience for your events."
        />
        <link
          rel="canonical"
          href="https://theexpresscaterers.in/"
        />

        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content="Caterers in Dahisar | The Express Caters" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://theexpresscaterers.in/" />
        <meta property="og:description" 
        content="Looking for reliable Caterers in Dahisar?The Express catering services provide the best culinary experience for your events." />

      </MetaTags>
       {/* --------------------------------seo end--------------------------------- */}
      <Swiper pagination={true} modules={[Pagination]} className="mySwiper">
        <SwiperSlide>
          <img src={pic} alt="Express Caterers-Tiny Parties or Lavish Wedding" />
          <div class="bannerText">
            <div className="one">
              <Zoom left>
                <h1> Caterers in Dahisar </h1>
                <p>
                  Tiny Parties or Lavish Wedding
                  <br />
                  we take care of them all
                </p>
              </Zoom>
            </div>
          </div>
        </SwiperSlide>
        {/* <SwiperSlide>
            <img src={pic1} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={pic3} />
          </SwiperSlide> */}
        {/* <SwiperSlide>Slide 4</SwiperSlide>
        <SwiperSlide>Slide 5</SwiperSlide>
        <SwiperSlide>Slide 6</SwiperSlide>
        <SwiperSlide>Slide 7</SwiperSlide>
        <SwiperSlide>Slide 8</SwiperSlide>
        <SwiperSlide>Slide 9</SwiperSlide> */}
      </Swiper>

      <section className="luxurious">
        <div className="container">
          <div className="titleSection">
            <span>
            AT "THE EXPRESS CATERERS IN DAHISAR ", WE BELIEVE IN DREAMING BIGGER AND AIM TO SPREAD THE JOY OF OUR DELICIOUS CUISINES AND SPECTACULAR SERVICE FAR AND WIDE IN MUMBAI.

            </span>
            <Zoom>
              {" "}
              <h2> BEST WEDDING CATERER IN DAHISAR MUMBAI.</h2>
            </Zoom>

            <p>
            We have maintained our stringent standards of food quality, cuisine innovation and presentation innovation, which have garnered glowing compliments from our guests! And our professional services have ensured that the guests leave with the biggest smiles on their faces! We provide total Food solutions for all Occasions.
            </p>
          </div>

          <div class="row">
            <div class="col-md-6 p-1">
              <div class="cardImg">
                <img src={food1} alt="quality food"/>
                <div class="overlay">
                  <h2>Express Way</h2>
                </div>
              </div>
            </div>
            <div class="col-md-6 p-1">
              <div class="cardImg">
                <img src={food2} alt="delicious taste"/>
              </div>
            </div>
            <div class="col-md-6 p-1">
              <div class="cardImg">
                <img src={food3} alt="presentable"/>
              </div>
            </div>
            <div class="col-md-6 p-1">
              <div class="cardImg">
                <img src={food4} alt="hygeine"/>
              </div>
            </div>
          </div>
          {/*  */}
        </div>
      </section>
      <section className="innovative mt-lg-5 mt-2" id=" ">
        <div className="container ">
          <div className="row d-flex justify-content-center ">
            <div className="col-md-6"></div>

            <div className="col-md-6">
              <Slide bottom>
                <div className="innovDetail">
                  <h1>Fine Catering Services since 1987</h1>
                  <p>
                    {" "}
                    <span style={{ color: "red", fontWeight: "700" }}>
                    “The Express Caterers” 
                    </span>
                   was launched in 1987 by Mr. Brazil Colaco who has a degree from Sophia Catering Institute Mumbai and a vast Five Star experience in production (Kitchen) as well as service experience international and National. He has successfully managed to diffuse his rich Five Star exposure into his middle class clientele setup at an affordable price. Everything from its taste to its look is a result of our unfaltering poetic passion and tremendous love for what we do. As the best caterers in Dahisar,We aim to provide our customers with premier quality food.

                    middle class clientele setup at an affordable price.
                    Everything from its taste to its look is a result of our
                    unfaltering poetic passion and tremendous love for what we
                    do. We aim to provide our customers with premier quality
                    food.
                  </p>
                </div>
              </Slide>
            </div>
          </div>
        </div>
      </section>

      <section className="events">
        <div className="container">
          <div class="row d-flex justify-content-center align-items-center pt-lg-5 pt-2">
            <div class="col-md-6 col-12">
              <div className="eventTitle">
                <Zoom>
                  <span>Why choose us</span>
                  <h2>Our Specialities</h2>
                  <p>
                  No celebration is complete without delicious food and a warm welcome. And we understand that more than anyone else! The Express Caterers in dahisar has risen to be among the top favorites of people not just within Mumbai but beyond – and there’s a good reason for it! Our understanding of Multi cuisines, our innovative bend of mind that ensures we customize every dish as per your event theme and our focus on warm-hearted service that leaves a wide smile on your guest’s face – all of this comes together to create an experience to remember!

                  </p>
                  <p>
                  If you are looking to host an event where you can hand over all your culinary and hospitality responsibilities without any worries to
 is your best companion. We don't just provide you our service, we EXPRESS it too.

                    <br />
                    <span style={{ color: "red", fontWeight: "bold" }}>
                      {" "}
                      “THE EXPRESS CATERERS”
                    </span>{" "}
                    is your best companion we don’t just provide you our service
                    we EXPRESS it too.
                  </p>
                </Zoom>
              </div>
            </div>
            <div class="col-md-6 col-12 ">
              <div class="cardImg">
                <img src={pic1} alt="customized dishes"/>
              </div>
            </div>
          </div>
          {/* <div class="row pt-lg-2">
                <div class="col-md-4 d-flex justify-content-center p-1">
                  
                    <div class="cardImg">
                    <img src={wood} />
                    </div>
                    
                  
                </div>
                <div class="col-md-4 d-flex justify-content-center p-1">
               
                    <div class="cardImg">
                    <img src={kadhai} />
                    </div>
                 
                </div>
                <div class="col-md-4 d-flex justify-content-center p-1">
                
                    <div class="cardImg">
                    <img src={food5} />
                    </div>
                 
                </div>
               
              </div> */}
        </div>
      </section>

      <div className="titleSection">
        <h2>What makes us different</h2>
      </div>
      <section className="facilitiesSection mt-lg-5 mt-2" id=" ">
        <div className="container ">
          <div className="row d-flex justify-content-center ">
            <div className="col-md-4">
              <div className="card ">
                <div className="card-img-top ">
                  <img src={ficon1} alt="Appetizing Food Quality:"/>
                </div>
                <Slide bottom>
                  <div className="cardTitle ">
                    <h2>Appetizing Food Quality: </h2>
                    <p>
                    Our Various Cuisines Are Delicious, High Quality And Handpicked To Sit Every Occasion! Food That Tells A Story.

                    </p>
                  </div>
                </Slide>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card ">
                <div className="card-img-top ">
                  <img src={ficon2} alt="Tempting Food Presentation"/>
                </div>
                <Slide bottom>
                  <div className="cardTitle ">
                    <h2>Tempting Food Presentation</h2>
                    <p>
                    We Are Known For Our Stunning Food Presentations, Complete With Handpicked Crockery To Suit The Unique Event Theme!

                    </p>
                  </div>
                </Slide>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card ">
                <div className="card-img-top ">
                  <img src={ficon3} alt="Immaculate Cuisine Innovation"/>
                </div>
                <Slide bottom>
                  <div className="cardTitle ">
                    <h2>Immaculate Cuisine Innovation:</h2>
                    <p>
                    We Take The Liberty Of Experimenting And Innovating The Cuisines That We Serve, So That Your Guests Always Have Something New To Look Forward To! Fulfill Your Comfort Food Cravings.

                    </p>
                  </div>
                </Slide>
              </div>
            </div>
            <div className="row mt-lg-5 mt-2">
              <div className="col-md-2"></div>
              <div className="col-md-4">
                <div className="card ">
                  <div className="card-img-top ">
                    <img src={ficon4} alt="Customised food preparation"/>
                  </div>
                  <Slide bottom>
                    <div className="cardTitle ">
                      <h2>Customised food preparation</h2>
                      <p>
                      Every Event Has A Different Vibe And Theme And We Customize Our Delicious Preparations Accordingly, So That You Get The Finest Experience! Where Every Flavor Tells A Story.
                      </p>
                    </div>
                  </Slide>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card ">
                  <div className="card-img-top ">
                    <img src={ficon4} alt="Attentive Services"/>
                  </div>
                  <Slide bottom>
                    <div className="cardTitle ">
                      <h2>Attentive Services</h2>
                      <p>
                      We Pick Only Skilled And Courteous Staff And Train Them Well, So That They Attend To Your Guests And Make Them Feel Welcome! We Not Only Provide Our Services We EXPRESS It.

                      </p>
                    </div>
                  </Slide>
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
        </div>
      </section>

      <section id="about-area" className="">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-6 col-12">
              <div className="about-content">
                <div className="eventTitle">
                  <Zoom>
                    <span>Get in touch</span>
                    <h2>just one call away</h2>
                    <p>
                    Get the best quote from “The Express Caterers” in dahisar and book your date, plan your wedding hassle free. Call us on the no. 9820124036 or 9820143669
                    </p>
                  </Zoom>

                  <a href="contact.html" className="default-btn">
                    <span>order now</span>
                  </a>
                </div>
                <Slide bottom>
                  <div className="section-title">
                    <div className="row d-flex justify-content-center">
                      <div className="col-lg-6 col-md-6">
                        <div className="bookTab">
                          <div className="contact">
                            <a href="tel:+9820143669">
                              <img src={smartphone} alt="call now"/>
                            </a>
                          </div>
                          <div className="bookTitle">
                            <h2>Phone</h2>
                            <p>9820143669</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6">
                        <div className="bookTab">
                          <div className="contact">
                            <a href="https://wa.me/9820143669">
                              <img src={whatsapp} alt="whatsapp"/>
                            </a>
                          </div>
                          <div className="bookTitle">
                            <h2>Whatsapp</h2>
                            <p>9820143669</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slide>
              </div>
            </div>
            <div className="col-lg-7 col-md-5 col-12 m-0 p-0">
              <div className="about-image">
                <img src={cheese} class="reach The Express Caterers" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <button
        className="enquireButton"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
        onClick={handleShow}
      >
        Enquiry Now
      </button>
      <Modal
        show={show}
        id="exampleModal"
        backdrop="static"
        keyboard={false}
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        onHide={handleClose}
      >
        <Modal.Body>
          <div className="partnerProgramForm">
            <div className="formTitleSection">
              <div className="modal-content">
                <div className="modal-header ml-5">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Enquiry Now
                  </h5>
                  <div
                    className="closeProgram closeProgram1"
                    onClick={handleClose}
                  >
                    {" "}
                    <i className="fa fa-times" />{" "}
                  </div>
                </div>
                <div className="modal-body">
                  <div className="col-lg-12">
                    <form
                      action=""
                      method="post"
                      role="form"
                      className="php-email-form"
                    >
                      <div className="row">
                        <div className="col-md-6 form-group">
                          <input
                            type="text"
                            name="name"
                            className="form-control input1"
                            id="custName"
                            placeholder="Your Name"
                            required=""
                          />
                        </div>
                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <input
                            type="number"
                            className="form-control input1"
                            name="phone"
                            id="custPhone"
                            placeholder="Your Phone No"
                            required=""
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <input
                          type="email"
                          className="form-control input1"
                          name="email"
                          id="custEmail"
                          placeholder="Your Email"
                          required=""
                        />
                      </div>
                      <div className="form-group mt-3">
                        <textarea
                          className="form-control input1"
                          name="message"
                          id="custMessage"
                          rows={6}
                          placeholder="Message"
                          required=""
                          defaultValue={""}
                        />
                      </div>
                      {/* <div className="my-3">
          <div className="loading">Loading</div>
          <div className="error-message" />
          <div className="sent-message">
            Your message has been sent. Thank you!
          </div>
        </div> */}
                      <div className="text-center submitTarget">
                        <button type="submit" onClick={formSubmit}>
                          Send Message
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Footer />
    </>
  );
};

export default Home;
